export const AppContext = {
  farmi: 'farmi',
  aladin: 'aladin',
  episens: 'episens',
  countrymalt: 'countrymalt',
  jardiland: 'jardiland',
  gammvert: 'gammvert',
} as const

export type AppContext = (typeof AppContext)[keyof typeof AppContext]
